export default function Contact() {
  return (
    <section id="contact" className="bg-[#1a2332] text-white">
      <div className="max-w-7xl mx-auto px-8 lg:px-16 py-24">
        <div className="mb-16">
          <h2 className="text-6xl lg:text-7xl font-bold text-white mb-8">
            BLANKA d.o.o.
          </h2>
          <p className="text-gray-300 text-lg leading-relaxed max-w-xl">
            A team of experts developing modern applications for the iOS platform, dedicated to enhancing user experience and improving the security of mobile devices.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-16">
          <div>
            <h3 className="text-[#06b6d4] text-xs font-bold tracking-[0.2em] uppercase mb-5">
              ADDRESS
            </h3>
            <div className="space-y-2 text-white text-base">
              <p>Kralja Petra Kresimira IV 124</p>
              <p>Makarska</p>
              <p>21300</p>
              <p>Croatia</p>
            </div>
          </div>
          
          <div>
            <h3 className="text-[#06b6d4] text-xs font-bold tracking-[0.2em] uppercase mb-5">
              PHONE
            </h3>
            <p className="text-white text-base mb-10">+1 5706308293</p>
            
            <h3 className="text-[#06b6d4] text-xs font-bold tracking-[0.2em] uppercase mb-5">
              EMAIL
            </h3>
            <p className="text-white text-base">info@blankadoo.com</p>
          </div>
          
          <div className="flex items-center justify-center md:justify-end">
            <div className="relative w-full max-w-sm h-80 rounded-2xl overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-[#06b6d4]/20 to-[#3b82f6]/20 blur-2xl"></div>
              <img
                src="https://public.readdy.ai/ai/img_res/996d7e9f95a7572d052a9f65da87a506.jpg"
                alt="iOS Technology"
                className="relative z-10 w-full h-full object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700/40 pt-10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <p className="text-gray-400 text-sm">
              © 2025 BLANKA d.o.o.
            </p>
            
            <div className="flex items-center space-x-8">
              <span className="text-gray-400 text-sm cursor-pointer hover:text-white transition-colors whitespace-nowrap">
                Privacy
              </span>
              <span className="text-gray-400 text-sm cursor-pointer hover:text-white transition-colors whitespace-nowrap">
                Terms
              </span>
              <span className="text-gray-400 text-sm cursor-pointer hover:text-white transition-colors whitespace-nowrap">
                Security
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}